export default __webpack_public_path__ + "42218b1c698f9f3c04bf0a404212fbd1.png";